import { render, staticRenderFns } from "./HeaderMenuModal.vue?vue&type=template&id=09673708&scoped=true"
import script from "./HeaderMenuModal.vue?vue&type=script&lang=js"
export * from "./HeaderMenuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09673708",
  null
  
)

export default component.exports